<!--
    描述：租户用户表单
    日期：2021/04/16
    作者：zwh
-->
<template>
	<div class="tua-main-dialog">
		<el-row>
			<el-col :span="24">
				<el-input placeholder="请输入姓名"
						  v-model="searchObj.sname"
						  class="input-with-select">
					<el-button slot="append"
							   icon="el-icon-search"
							   @click="search"></el-button>
				</el-input>
			</el-col>
		</el-row>
		<el-row class="mt5">
			<el-col :span="24">
				<el-table ref="table"
						  v-loading="tableObj.loading"
						  :data="tableObj.tableData"
						  default-expand-all
						  :height="tableObj.tableH"
						  border
						  highlight-current-row>
					<el-table-column type="index"
									 align="center"
									 width="50"></el-table-column>
					<el-table-column align="center"
									 width="50">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.isChecked"
										 @change="handleCheck($event, scope.row)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="sname"
									 header-align="center"
									 align="center"
									 label="姓名"
									 show-overflow-tooltip
									 min-width="100"></el-table-column>
					<el-table-column prop="username"
									 header-align="center"
									 align="center"
									 label="用户名"
									 show-overflow-tooltip
									 min-width="100"></el-table-column>
				</el-table>
			</el-col>
		</el-row>

	</div>
</template>
<script>
import { savePlatformUserTenantBatch } from 'api/system/sysUserTenant.js'
import { importUsers, saveImportUsers } from 'api/system/user.js'
export default {
	name: '',
	props: {
		mode: {
			type: String,
			default: 'add',
		},
		transObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},

	data() {
		return {
			btnLoading: false,
			//搜索条件对象
			searchObj: {
				sname: '',
			},
			objectForm: {},
			formRules: {},
			tableObj: {
				loading: false,
				tableH: 445,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100], // 显示条数数组
			},
			//导入用户：选择人员信息
			userCheckedList: [],
			//导入用户：选择人员id信息
			userCheckedIdList: [],
		}
	},
	mounted() {},
	computed: {
		// 是否可编辑
		isDisabled() {
			return this.mode === 'view' ? true : false
		},
	},
	watch: {},
	created() {
		//获取人员列表信息
		this.getTablePageList()
	},
	methods: {
		//搜索
		search() {
			this.getTablePageList()
		},
		//获取人员列表信息
		getTablePageList() {
			let that = this
			let param = {
				userSname: this.searchObj.sname,
			}
			importUsers(param).then((res) => {
				this.tableObj.tableData = []
				if (res.operationCode == 1 && res.data != null) {
					let data = res.data
					/*
                    data.forEach(row=>{
                        let index = that.userCheckedIdList.findIndex(userId=> { return userId == row.id })
                        if(index != -1) row.isChecked = true
                        else row.isChecked = false
                    })
                    */
					this.tableObj.tableData = data
				}
			})
		},
		// 数据权限复选框 check 事件
		handleCheck(status, row) {
			let that = this
			console.log(status)
			if (status) that.userCheckedIdList.push(row.id)
			else {
				let index = that.userCheckedIdList.findIndex((userId) => {
					return userId == row.id
				})
				that.userCheckedIdList.splice(index, 1)
			}
			console.log(that.userCheckedIdList)
		},
		//保存
		doSave() {
			let that = this
			if (this.userCheckedIdList.length < 1) {
				this.$message({ message: '请选择用户！', type: 'warning' })
				return
			}

			let param = that.userCheckedIdList
			saveImportUsers(param).then((res) => {
				if (res.operationCode == 1) {
					this.$message({ message: '保存成功！', type: 'success' })
					this.$emit('handle-success')
				}
			})
		},
	},
}
</script>
